module.exports = __webpack_public_path__ + "img/warning_urgent.svg";